<template>
  <div id="camaras_div" v-if="camarasLoaded ==true">   
    <div id="cams-manage" class="d-flex justify-content-center col-12" v-if="Mosaico">      
      <div v-for="Camara in Camaras" v-if="Camara.TipoCamara.TipoCamaraId < 7" :class="construyeLaClaseDeLaCamara(Camara.TipoCamara.TipoCamaraId)">
        <span class="+">{{Camara.TipoCamara.Nombre}}</span>           
        <!-- <img :src="Camara.IP" controls = "true" :id="Camara.TipoCamara.TipoCamaraId == 5 && sesion.Camaras.find(video => video.TipoCamara.TipoCamaraId == 5).ElVideoSeDifumina != null && (sesion.Camaras.find(video => video.TipoCamara.TipoCamaraId == 5).ElVideoSeDifumina == true || sesion.Camaras.find(video => video.TipoCamara.TipoCamaraId == 5).ElVideoSeDifumina == 'true') ? 'videoProtegido' : 'sinProtegido'"/> Inicial -->
        <!-- <img :src="Camara.IP" controls = "true" :id="Camara.TipoCamara.TipoCamaraId == 5 && sesion.RutasDeVideos[0].ElVideoSeDifumina != null && (sesion.RutasDeVideos[0].ElVideoSeDifumina == true || sesion.RutasDeVideos[0].ElVideoSeDifumina == 'true') ? 'videoProtegido' : 'sinProtegido' " @click="eventCamara($event)"/>  -->
        <img  :src="Camara.IP" controls = "true" :id="Camara.TipoCamara.TipoCamaraId == 5 && sesion.RutasDeVideos[0].ElVideoSeDifumina != null && (sesion.RutasDeVideos[0].ElVideoSeDifumina == true || sesion.RutasDeVideos[0].ElVideoSeDifumina == 'true')  ? 'videoProtegido' : Camara.TipoCamara.TipoCamaraId " @click="eventCamara($event)"/>
      </div>
      <div v-else-if="Camara.TipoCamara.TipoCamaraId == 7" :id="construyeNombre('cameraEvidenziador')" :class="construyeLaClaseDeLaCamara(Camara.TipoCamara.TipoCamaraId)"  >
        <span class="+">{{Camara.TipoCamara.Nombre}}</span>
        <img  :src="Camara.IP" controls = "true" :id="Camara.TipoCamara.TipoCamaraId == 5 && sesion.RutasDeVideos[0].ElVideoSeDifumina != null && (sesion.RutasDeVideos[0].ElVideoSeDifumina == true || sesion.RutasDeVideos[0].ElVideoSeDifumina == 'true')  ? 'videoProtegido' : Camara.TipoCamara.TipoCamaraId " @click="eventCamara($event)"/>
      </div>
    </div>
    
    <div v-else id="cams-manage" class="col-12">
        <img :class="construyeNombre('ImageSize')" :src="CamarasAMostrar[0].IP" controls = "true" :id="CamarasAMostrar[0].TipoCamara.TipoCamaraId == 5 && sesion.RutasDeVideos[0].ElVideoSeDifumina != null && (sesion.RutasDeVideos[0].ElVideoSeDifumina == true || sesion.RutasDeVideos[0].ElVideoSeDifumina == 'true') ? 'videoProtegido' : CamarasAMostrar[0].TipoCamara.TipoCamaraId "  @click="eventCamara($event)"/>
    </div>
    <!-- <div v-if="sesion.Sala != undefined"> -->
      <!-- <audio id="audio_forseti" :src='sesion.Sala.IPDeTransmision' type="audio/mp3" :controls='false' ></audio> -->
    <!-- </div> -->
   </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        sesion: Object,
        Camaras: [],
        CamarasAMostrar: [],
        Mosaico: true,
        targetCamScr : 0,
        camarasLoaded : false,
        audioSource : null
      }
    },
    props: {
      parametros: Object,
      esEnVivo:{type:Boolean, default: false}
    },
    mounted() { 
      this.cargaCamaras();
                  
      if (this.parametros.SesionDeLaAudienciaId != undefined) {
        this.sesion = this.parametros;
      }      
      else if (this.parametros.AudienciaId != undefined) {

        this.sesion = this.parametros.SesionesDeLasAudiencias.find(sesion => sesion.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 3)
      };
    },
    methods: {
      construyeLaClaseDeLaCamara: function ( tipoCamaraId) {
        var camSize = this.Camaras.length>6 ? 3 : 4
         var style = "";
        if(tipoCamaraId==7){
        switch(this.Camaras.length){
      case 7:
        style="evidencia_7";        
        break;
         default:
        style="evidencia";
         break;
        }
        if(this.esEnVivo){ style=style+"_Vivo";}
        }else{
          style = (this.esEnVivo?"camVivo":"cam");
        }
        style=style+ " d-flex justify-content-center col-"+camSize;
        return style; //tamanoDeLaCamara por estilo;
      },
      construyeNombre(tipoID){ //metodo para el id ImageSizeVivo
        var name=(this.esEnVivo?(tipoID+"Vivo"):tipoID);
        return name;
      },
      cargaCamaras: function () {         
        const parametrosDeLasCamaras = {}
        if (this.parametros != null && this.parametros != undefined && this.parametros.Sala != undefined && this.parametros.Sala.SalaId != undefined) {
          parametrosDeLasCamaras.SalaId = this.parametros.Sala.SalaId;
          parametrosDeLasCamaras.conTipoCamara = true;
          parametrosDeLasCamaras.EsPrueba = this.enumeraciones.EsPrueba;
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.Forseti.catalogos.C011Camaras, parametrosDeLasCamaras)
            .then(respuesta => {
              if (respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else {
                if(this.accesos(respuesta.data.Camaras)==true)
                {
                  this.Camaras = respuesta.data.Camaras;
                  this.CamarasAMostrar = respuesta.data.Camaras;
                }
                else{
                  this.camarasLoaded = false;
                }
              }
            })
            .catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            })
            comun.SeEstaCargandoInformacion(false);
        }
      },
      eventCamara: function(evento){
        var idControl = 0;
        if(evento.target.id.length==1)
        {
          idControl = parseInt(evento.target.id);
        }
        else {
          var ObtenerDifuminada = this.Camaras.filter(e=>e.TipoCamara.Nombre == "Protegido");
          idControl = ObtenerDifuminada[0].TipoCamara.TipoCamaraId;
        }
        
        if(this.Mosaico ==true)
        {
          var listadoTemporal = this.Camaras;
          this.targetCamScr =idControl;
          this.CamarasAMostrar = listadoTemporal.filter(e=>e.TipoCamara.TipoCamaraId == this.targetCamScr)
          listadoTemporal = null;
          this.Mosaico=false;
        }
        else{
          if(this.targetCamScr == idControl)
          {
            this.CamarasAMostrar = [];
            var listadoTemporal = this.Camaras;
            this.CamarasAMostrar = listadoTemporal;
            this.Mosaico = true;
            listadoTemporal= null;
          }
        }
      },
      accesos: function(datos) {
        let _this=this
        this.camarasLoaded = false;
        let estatus = false;
        try{
          let Camara1 = null;
          let Camara2 = null;
          let Camara3 = null;
          let Camara4 = null;
          let Camara5 = null;
          let Camara6 = null;
          //let Camara7 = null;
          let url = ""
           
        // for (var index = 0; index < datos.length; index ++)
        // {
          
        $.each(datos, function(id, camara)
        {
          var longitud = camara.IP.length;
          url = "http://" + (camara.KeyTransmision!=null ? camara.KeyTransmision : '') + camara.IP.substring(7, longitud);
          //abrimos ventanas emergentes para generar cookie de acceso a camaras
          switch(camara.TipoCamara.TipoCamaraId)
          {
            case 1:
              
                Camara1 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
             
              break;
            case 2:
               
                Camara2 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
              
              break;
            case 3:
                
                Camara3 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
              
              break;
            case 4:
                
                Camara4 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
              
              break;
            case 5:
                
                Camara5 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
              
              break;
            case 6:
                
                Camara6 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
              
              break;
            case 7:
              
              var peticion={"Camaras": camara}
             
                  axios.post(
          'http://' + _this.sesion.Sala.IP + _this.sesion.Sala.PuertoDeGrabacion + "/IniciaMPJPEG",
          {peticion},
         
          ).then(respuesta => {
            if (respuesta.Error != undefined) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.Error, null, null);
              throw respuesta
            } 
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
                
                //Camara7 = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0,visible=none');
              
              break;
          };
        });
        //};
        //cerramos ventanas emergentes
        setTimeout(()=>{
          if (Camara1!=null)
          {
            Camara1.close();
          }
          if (Camara2!=null)
          {
            Camara2.close();
          } 
          if (Camara3!=null)
          {
            Camara3.close();
          }
          if (Camara4!=null)
          {
            Camara4.close();
          }
          if (Camara5!=null)
          {
            Camara5.close();
          }
          if (Camara6!=null)
          {
            Camara6.close();
          }
         
          this.camarasLoaded = true;
          }, 600);
          estatus = true;
        }
        catch (e)
        {
          estatus= false
          console.log(e)
        }
        return estatus;
      },
    },
    beforeDestroy() {
      
    }    
  }
</script>
<style scoped>
  #cams-manage {
    display: flex;
    flex-wrap: wrap;
    position: relative;
  }

  .cam video {
    width: 100%;
  }
  .ImageSize {
    width:  75vw;
    height: 75vh;
    border-radius: 2px;
    box-shadow: 2px 2px 3px 2px rgba(0, 0, 0, 0.5);
    transition: width 1s;
    align-self: normal;
    align-items: center;
    cursor: ne-resize;
  }
  .cam {
    padding: 0;    
    background-color: #000;
    height: 30vh;
    display: inline-table;
    justify-content: center;
    align-items: center;
    font-size: 4em;
    border: 4px solid #323335;
    position: relative;
    cursor: all-scroll;
  }

    .cam span {
      font-size: 0.4em;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }

    .cam button {
      position: absolute;
      font-size: 16px;
      top: 8px;
      right: 10px;
      background-color: #000;
      color: #FFF;
      border: none;
    }



  .camVivo video {
    width: 100%;
    
  }
  .ImageSizeVivo {
    
    width: 90vw;
    height: 90vh;
    border-radius: 2px;
    box-shadow: 2px 2px 3px 2px rgba(0, 0, 0, 0.5);
    transition: width 1s;
    align-self: normal;
    align-items: center;
    cursor: ne-resize;
    
  }
  .camVivo {
    padding: 0;    
    background-color: #000;
    height: 30vh;
    display: inline-table;
    justify-content: center;
    align-items: center;
    font-size: 4em;
    border: 4px solid #323335;
    position: relative;
    cursor: all-scroll;
    position: relative;
    top: 100px;
    
  }
   
   .camVivo img {
      display: inline-block;
  width:  100%;
  height: 100%;
  border: 1px solid;
    }
    .camVivo span {
      font-size: 0.4em;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }

    .camVivo button {
      position: absolute;
      font-size: 16px;
      top: 8px;
      right: 10px;
      background-color: #000;
      color: #FFF;
      border: none;
    }

    
    #cameraEvidenziador{
    padding: 0;    
    background-color: #000;
    
    display: inline-table;
    justify-content: center;
    align-items: center;
    
    border: 5px solid #323335;
    position: relative;
    cursor: all-scroll;
    max-width: 50%;
      max-height: 75%;
    }
    .evidencia_7 img {
      height: 180px;
      width: 260px;
      max-width: 100%;
    }
    
    .evidencia_7 span {
      font-size: 1.4em;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }
   
    .evidencia img {      
      top: 10px;
      height: 280px;
      width: 350px;
      max-width: 100%;
    }
    
    .evidencia span {
      font-size: 1.4em;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }

    #cameraEvidenziadorVivo{
    padding: 0;    
    background-color: #000;
    
    display: inline-table;
    justify-content: center;
    align-items: center;
    
    border: 1px solid #fcfcfc;
    position: relative;
    cursor: all-scroll;
    max-width: 35%;
    max-height: 35%;
    top:100px;
    }
    .evidencia_7_Vivo img {
      height: 100%;
      width: 98%;
      max-width: 100%;
      
    }
    
    .evidencia_7_Vivo span {
      font-size: 1.4em;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }

    .evidencia_Vivo img {
      
      height: 265px;
      width:  100%;
      
      max-width: 980%;
      
    }
    .evidencia_Vivo span {
      font-size: 1.4em;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }
    
  video {
    width: 100%;
    height: 100%;
    position: relative;
  }

  audio {
    width: 100%;
    height: 100%;
    position: relative;
  }

  #videoProtegido {
    filter: blur(20px);
  }
  
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/Camaras.vue